import React from 'react'
import styled from 'styled-components'
import { Close } from '../../../assets/icons'

const TagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: ${props => props.theme.colors.brand.backgroundBlue};
  color: ${props => props.theme.colors.brand.blueOmint};
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`

const RemoveButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:hover {
    opacity: 0.7;
  }
`

const Tag = ({ label, onRemove }) => (
  <TagContainer>
    {label}
    <RemoveButton type="button" onClick={onRemove} aria-label={`Remover ${label}`}>
      <Close width={14} height={14} />
    </RemoveButton>
  </TagContainer>
)

export default Tag
